import * as types from './types'

export const getCompaniesRequest = () => ({
  type: types.GET_ADMIN_COMPANIES_REQUEST,
})
export const getCompaniesSuccess = (result) => ({
  type: types.GET_ADMIN_COMPANIES_SUCCESS,
  payload: result,
})
export const getCompaniesError = (error) => ({
  type: types.GET_ADMIN_COMPANIES_ERROR,
  payload: error,
})
